const common = {
    no_data: 'Tidak ada data',
    header: {
        business_name: 'Bisnis Anda'
    },
    download_app: {
        text: 'Untuk menggunakan versi web Simply, silakan gunakan laptop atau PC.',
        button: 'Unduh versi seluler'
    },
    unknown: 'Tidak diketahui',
    request_error: 'Terjadi kesalahan. Silakan coba lagi! Atau hubungi dukungan pelanggan untuk melaporkan masalah Anda.',
    home: 'Beranda',
    dashboard: 'Dasbor',
    product: 'Produk',
    add_product: 'Tambah Produk',
    edit_product: 'Edit Produk',
    stock_in: 'Stok Masuk',
    Sales_Turnover: 'Perputaran Penjualan',
    profit: 'Keuntungan',
    stock_out: 'Stok Keluar',
    staff: 'Staf',
    stock_audit: 'Audit Stok',
    button: {
        save: 'Simpan',
        save_and_add_more: 'Simpan & Tambah Lagi',
        submit: 'Kirim',
        done: 'Selesai',
        edit: 'Edit',
        save_edit: 'Simpan Perubahan',
        yes: 'Ya',
        clear: 'Bersihkan',
        delete: 'Hapus',
        cancel: 'Batal',
        reset: 'Atur Ulang'
    },
    select_date: 'Pilih Tanggal',
    select_action: 'Pilih Tindakan',
    mandatory: ' *(Wajib)',
    not_mandatory: '(Tidak Wajib)',
    business: 'Bisnis',
    account: 'Akun',
    profile: 'Profil',
    setting: 'Pengaturan',
    whichLanguage: 'Bahasa Indonesia',
    headerDashboard: 'Jadi VIP',
    contact_us: 'Hubungi Kami',
    logout: 'Keluar',
    confirm_logout: 'Apakah Anda yakin ingin keluar?',
    logout_description: 'Anda harus masuk lagi untuk mengakses bisnis Anda.',
    category: 'Kategori',
    add_category: 'Tambah Kategori',
    data: 'Data',
    history: 'Riwayat',
    lowStockAlert: 'Peringatan Stok Rendah',
    Expenses: 'Pengeluaran',
    lowStockAlertButton: 'Tambahkan Jumlah Stok Aman',
    message: {
        login_success: 'Berhasil Masuk!',
        onboard_success: 'Hore!! Perjalanan Anda telah dimulai!',
        successfully_saved: 'Data berhasil disimpan',
        successfully_deleted: 'Data berhasil dihapus',
        error_required_field: 'Kolom wajib tidak boleh kosong',
        no_access: 'Tidak ada akses',
        no_permission: "Anda tidak memiliki izin",
        error_update_history: 'Gagal memperbarui riwayat'
    },
    no_permission_dialog: {
        title: 'Tidak Ada Izin',
        description: 'Anda tidak memiliki izin untuk melihat Pengeluaran. Silakan hubungi administrator Anda.'
    },
    feedback: 'Beri masukan',
    contact: 'Kontak',
    add: 'Tambah',
    supplier: 'Pemasok',
    customer: 'Pelanggan',
    random: 'Acak',
    scan: 'Pindai',
    enter: 'Masuk dengan memindai barcode',
    terms: {
        text: 'Dengan melanjutkan, Anda setuju dengan',
        link: 'Kebijakan Privasi'
    },
    others: 'Lainnya',
    calender: {
        presets: {
            today: 'Hari Ini',
            yesterday: 'Kemarin',
            last_7_days: '7 Hari Terakhir',
            last_30_days: '30 Hari Terakhir',
            this_month: 'Bulan Ini',
            last_month: 'Bulan Lalu',
            custom_range: 'Rentang Kustom'
        }
    },
    print_large: 'Cetak Besar (A4)',
    print_letter: 'Cetak Surat (US)',
    print_dot_matrix: 'Cetak Besar (Dot Matrix)',
    print_medium: 'Cetak Sedang (75mm)',
    print_small: 'Cetak Kecil (48mm)',
    format: 'Format Kertas',
    preview: 'Pratinjau',
    view_invoice: 'Faktur',
    view_chalan: 'Challan',
    price: 'Harga',
    stock: 'Stok',
    quantity: 'Kuantitas',
    total: 'Total',
    print_footer_left: 'Dibuat oleh',
    print_footer_center: 'Dicetak pada',
    print_footer_date: 'pada',
    print_to: 'Kepada',
    language: 'Bahasa Indonesia',
    dateStatus: '7 Hari Terakhir',
    placeholder: 'Jenis Transaksi',
    staffHistory: 'Pilih Staf',
    languageTitle: 'Bahasa Indonesia',
    date: 'Tanggal',
    download: 'Unduh',
    download_excel: 'Unduh Excel',
    download_pdf: 'Unduh Barcode',
    currentTitle: 'Mata Uang',
    Selectperiod: 'Pilih Periode',
    TransactionType: 'Jenis Transaksi',
    SelectCustomer: 'Pilih Pelanggan',
    invoice: 'Faktur',
    login: {
        google: 'Masuk dengan Google',
        apple: 'Masuk dengan Apple'
    },
    trusted_by: {
        title: 'Dipercaya oleh lebih dari 50.000 bisnis \n di seluruh Indonesia 🇮🇩'
    },
    privacyPolicyOne: "Dengan masuk, Anda setuju dengan",
    privacyPolicyTwo: 'Kebijakan Privasi Simply',
    manufacture: 'Pabrik',
    warehouse: 'Gudang',
    error: {
        title: 'Ups! Terjadi kesalahan',
        description: 'Terjadi kesalahan tak terduga. Silakan refresh halaman atau kembali ke beranda.',
        refresh: 'Refresh Halaman',
        go_back: 'Kembali ke Beranda',
        not_found: 'Halaman Tidak Ditemukan'
    },
    totalPurchasePrice: 'Total Harga Pembelian',
    pageTotalPurchaseAmount: 'Jumlah Total Pembelian Per Halaman',
    approval_status: 'Status persetujuan',
    pending: 'Tertunda',
    approved: 'Disetujui',
    rejected: 'Ditolak',
    select_fields: 'Pilih Bidang',
    syncWithTally: 'Sinkronkan dengan Tally',
    importFromTally: 'Impor dari Tally',
    exportToTally: 'Ekspor ke Tally',
    All: 'Semua',
    Approval: 'Persetujuan'
}

export default common

